import { render, staticRenderFns } from "./BxTableColumn.vue?vue&type=template&id=61461ad5&"
import script from "./BxTableColumn.vue?vue&type=script&lang=js&"
export * from "./BxTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports